module.exports = __webpack_public_path__ + "img/97ne.fc478a61.svg";